<div class="usuarios-inativos-container">
  <div class="header">
    <h1>Usuários Inativos</h1>
  </div>

  <!-- Filtros -->
  <div class="filtros-container mb-4">
    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <label for="filtroSobrenome">Sobrenome:</label>
          <input
            type="text"
            id="filtroSobrenome"
            class="form-control"
            [(ngModel)]="filtroSobrenome"
            (keyup)="aplicarFiltros()"
            placeholder="Filtrar por sobrenome">
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label for="filtroNome">Nome:</label>
          <input 
            type="text" 
            id="filtroNome" 
            class="form-control" 
            [(ngModel)]="filtroNome"
            (keyup)="aplicarFiltros()"
            placeholder="Filtrar por nome">
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label for="filtroCpf">CPF:</label>
          <input 
            type="text" 
            id="filtroCpf" 
            class="form-control" 
            [(ngModel)]="filtroCpf"
            (keyup)="aplicarFiltros()"
            placeholder="Filtrar por CPF">
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="filtroEmail">Email:</label>
          <input 
            type="email" 
            id="filtroEmail" 
            class="form-control" 
            [(ngModel)]="filtroEmail"
            (keyup)="aplicarFiltros()"
            placeholder="Filtrar por email">
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>&nbsp;</label>
          <button class="btn btn-secondary w-100" (click)="limparFiltros()">
            <i class="fa fa-times"></i> Limpar
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="table-wrap">
    <table class="table table-usuarios">
      <thead>
        <tr>
          <th class="col-sobrenome sortable" (click)="ordenarPor('sobrenome')">
            Sobrenome <i class="fa" [ngClass]="iconeOrdenacao('sobrenome')"></i>
          </th>
          <th class="col-nome sortable" (click)="ordenarPor('nome')">
            Nome <i class="fa" [ngClass]="iconeOrdenacao('nome')"></i>
          </th>
          <th class="col-cpf sortable" (click)="ordenarPor('cpf')">
            CPF <i class="fa" [ngClass]="iconeOrdenacao('cpf')"></i>
          </th>
          <th class="col-contato sortable" (click)="ordenarPor('contato')">
            Contato <i class="fa" [ngClass]="iconeOrdenacao('contato')"></i>
          </th>
          <th class="col-email sortable" (click)="ordenarPor('email')">
            Email <i class="fa" [ngClass]="iconeOrdenacao('email')"></i>
          </th>
          <th class="col-perfil sortable" (click)="ordenarPor('perfilAcesso')">
            Perfil <i class="fa" [ngClass]="iconeOrdenacao('perfilAcesso')"></i>
          </th>
          <th class="col-data sortable" (click)="ordenarPor('dataCadastro')">
            Cadastro <i class="fa" [ngClass]="iconeOrdenacao('dataCadastro')"></i>
          </th>
          <th class="col-acoes">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let usuario of usuariosPaginados">
          <td class="col-sobrenome" [title]="usuario.sobrenome || '-'">{{ usuario.sobrenome || '-' }}</td>
          <td class="col-nome" [title]="usuario.nome">{{ usuario.nome }}</td>
          <td class="col-cpf">{{ usuario.cpf }}</td>
          <td class="col-contato">{{ usuario.contato }}</td>
          <td class="col-email" [title]="usuario.email">{{ usuario.email }}</td>
          <td class="col-perfil">
            <span [class]="getPerfilClass(usuario.perfilAcesso)">
              {{ usuario.perfilAcesso }}
            </span>
          </td>
          <td class="col-data">{{ usuario.dataCadastro | date:'dd/MM/yyyy' }}</td>
          <td class="col-acoes">
            <button class="btn btn-sm btn-warning" (click)="editarUsuario(usuario)" title="Editar">
              <i class="fa fa-edit"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="!loading && usuariosFiltrados.length === 0">
          <td colspan="8" class="text-center text-muted">Nenhum usuário inativo encontrado.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="usuariosFiltrados.length > 0">
    <div class="d-flex align-items-center">
      <span class="me-2">Itens por página:</span>
      <select class="form-control form-control-sm" style="width: 90px;" [(ngModel)]="itensPorPagina" (change)="alterarItensPorPagina()">
        <option [ngValue]="5">5</option>
        <option [ngValue]="10">10</option>
        <option [ngValue]="20">20</option>
        <option [ngValue]="50">50</option>
      </select>
    </div>

    <div class="text-muted">
      Página {{ paginaAtual }} de {{ totalPaginas || 1 }}
    </div>

    <div class="d-flex">
      <button class="btn btn-outline-secondary btn-sm me-2" (click)="paginaAnterior()" [disabled]="paginaAtual <= 1">Anterior</button>
      <button class="btn btn-outline-secondary btn-sm" (click)="proximaPagina()" [disabled]="paginaAtual >= totalPaginas">Próxima</button>
    </div>
  </div>

  <!-- Modal -->
  <ng-template #formModal>
    <div class="modal-header">
             <h4 class="modal-title">{{ usuarioSelecionado ? 'Editar Usuário' : 'Novo Usuário' }}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.dismiss()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="formUsuario" (ngSubmit)="onSubmit()" class="form-container">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="nome">Nome:</label>
              <input 
                type="text" 
                id="nome" 
                formControlName="nome" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('nome')"
                placeholder="Digite o nome completo">
              <small class="text-danger" *ngIf="isFieldInvalid('nome')">
                {{ getFieldError('nome') }}
              </small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="cpf">CPF:</label>
              <input 
                type="text" 
                id="cpf" 
                formControlName="cpf" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('cpf')"
                placeholder="000.000.000-00"
                (input)="formatarCPF($event)">
              <small class="text-danger" *ngIf="isFieldInvalid('cpf')">
                {{ getFieldError('cpf') }}
              </small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="contato">Contato:</label>
              <input 
                type="text" 
                id="contato" 
                formControlName="contato" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('contato')"
                placeholder="(00) 00000-0000"
                (input)="formatarContato($event)">
              <small class="text-danger" *ngIf="isFieldInvalid('contato')">
                {{ getFieldError('contato') }}
              </small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="email">Email:</label>
              <input 
                type="email" 
                id="email" 
                formControlName="email" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('email')"
                placeholder="seu@email.com">
              <small class="text-danger" *ngIf="isFieldInvalid('email')">
                {{ getFieldError('email') }}
              </small>
            </div>
          </div>
        </div>

                 <div class="row">
           <div class="col-md-12">
             <div class="form-group">
               <label for="perfilAcesso">Perfil de Acesso:</label>
               <select 
                 id="perfilAcesso" 
                 formControlName="perfilAcesso" 
                 class="form-control"
                 [class.is-invalid]="isFieldInvalid('perfilAcesso')">
                 <option value="">Selecione o perfil</option>
                 <option *ngFor="let perfil of perfisAcesso" [value]="perfil">{{ perfil }}</option>
               </select>
               <small class="text-danger" *ngIf="isFieldInvalid('perfilAcesso')">
                 {{ getFieldError('perfilAcesso') }}
               </small>
             </div>
           </div>
         </div>

        <div class="form-actions">
          <button type="button" class="btn btn-secondary" (click)="modalRef.dismiss()">Cancelar</button>
          <button type="submit" class="btn btn-primary ms-2" [disabled]="!formUsuario.valid">Salvar</button>
        </div>
      </form>
    </div>
  </ng-template>
</div> 